var XPortal = XPortal || {};
XPortal.CustomEvents = (function () {
    const helpers = {

        /* PPS01 -product unit price calculation on fly */
        async PPS01_UpdateSOLUnitPriceForLine(context, action, next) {
            if (!context || !action) return warn('event to [update unit price for line] has been called incorrectly!!!', 1);
            if (!context.isOneOfFields(action, "no", "quantity", "variantcode", "*") || !context.isForEntity("SalesOrderLine")) return;
            if (action.type != XPortal.Redusers.ACTIONS.DELETED_ENTITY && action.type != XPortal.Redusers.ACTIONS.EDIT_FIELD)
                return;

            const before = XPortal.Store.GetModelByName(action.model).entity;
            const dBfrNo = getObjValueLCase(before, "no");
            const dBfrQt = getObjValueLCase(before, "quantity");
            const dBfrVc = getObjValueLCase(before, "variantcode");
            next(action);
            action.preventDefault = true;

            const curModel = XPortal.Store.GetModelByName(action.model);
            const dAftNo = getObjValueLCase(curModel.entity, "no");
            let dAftQt = getObjValueLCase(curModel.entity, "quantity");
            dAftQt = isNaN(Number(dAftQt)) || Number(dAftQt) < 0 ? 0 : dAftQt;
            const lineId = getObjValueLCase(curModel.entity, "uniqueid");
            const variantcode = getObjValueLCase(curModel.entity, "variantcode");
            const uomCode = getObjValueLCase(curModel.entity, "unitofmeasurecode");
            const relateduniqueid = getObjValueLCase(curModel.entity, "relateduniqueid");

            const curEntityName = curModel.model.Alias.toLowerCase();
            const prtMName = XPortal.Store.GetParentModelName(action.model);
            const prtModel = XPortal.Store.GetModelByName(prtMName);
            const customerNo = getObjValueLCase(prtModel.entity, "selltocustomerno");
            const currencycode = getObjValueLCase(prtModel.entity, "currencycode");

            if (dBfrNo == dAftNo && dBfrQt == dAftQt && dBfrVc == variantcode && action.type != XPortal.Redusers.ACTIONS.DELETED_ENTITY || !dAftNo) return;

            warn('start: pps01 updating line unitprice by rules:' + action.field.field + '', -1, { dAftNo, dAftQt });
            XPortal.Store.GetRelatedData({
                url: "/umbraco/surface/PPackage/CalcProdUnitPrice", request: {
                    uniqueid: lineId,
                    parentInfo: getParentInfo(action.model),
                    entityAlias: curEntityName,
                    nodeId: curModel.model.NodeId,
                    no: dAftNo,
                    quantity: dAftQt,
                    variantcode,
                    customerNo,
                    currencycode,
                    uomCode,
                    relateduniqueid,
                    data: JSON.stringify(getSimpleProperties(curModel.entity))
                }
            }).then(function (response) {
                if (!response || response.State == -11 && !context.isOneOfFields(action, "*")) {
                    let $popup = $("#errorBox");
                    if (!$popup) return;
                    $popup.find('.modal-body p').text(response.Errors);
                    $popup.modal('show');
                    return;
                }
                if (!response || response.State < 0) return;

                updateTotalsFor(prtMName, action, response);

                const items = XPortal.Store.GetModelByName(action.model).GetGridItems();

                if (!items) return;

                const curEntity = items.find(item => item.UniqueId === response.Requested.Uniqueid);

                if (!curEntity) return;
                setItemDescription(response, curEntity, action);

                // use only DispatchForOtherEntity when dispatching to grant that switching between grid cells will now cause any issues
                XPortal.Events.helpers.DispatchForOtherEntity(action.model, curEntity, [
                    { name: "unitprice", value: getObjValue(response, "unitprice") },
                    { name: "lineamount", value: getObjValue(response, "AmountExclVAT") },
                    { name: "AmountIncludingVAT", value: getObjValue(response, "AmountInclVAT") },
                    { name: "VATProdPostingGroup", value: getObjValue(response, "VATProdPostingGroup") },
                    { name: "VATBusPostingGroup", value: getObjValue(response, "VATBusPostingGroup") },
                    { name: "VATPerc", value: getObjValue(response, "VATPercent") },
                    { name: "quantity", value: getObjValue(response, "Quantity") },
                ], true, null, true);

                const uprice = getObjValue(response, "unitprice");
                const quantt = getObjValue(curEntity, "quantity");
                const ruprice = uprice == null || isNaN(uprice) ? 0 : uprice;
                const vstatus = uprice == null || isNaN(uprice) ? "UnitPriceInvalid" : "";
                const vmssg = vstatus ? "Unit Price is Invalid" : "";
                XPortal.Store.DispatchByName(action.model, "validationstatus", vstatus);
                XPortal.Store.DispatchByName(action.model, "validationmessage", vmssg);
            });
        },
        /* PPS02 - Get order customer Info by No */
        async PPS02_GetСustomerInfoByNo(context, action, next) {
            if (!context || !action || !context.RelatedData.Customers) return warn('event to [update customer infor by no] has been called incorrectly!!!', 1);
            if (!context.isOneOfFields(action, "SellToCustomerNo") || !context.isForEntity("SalesOrderHeader")) return;//BillToCustomerName

            const before = XPortal.Store.GetModelByName(action.model).entity;
            const dBfrCNo = getObjValueLCase(before, "SellToCustomerNo");
            next(action);
            action.preventDefault = true;

            const curModel = XPortal.Store.GetModelByName(action.model);
            const dAftCNo = getObjValueLCase(curModel.entity, "SellToCustomerNo");
            if (!dAftCNo) return;

            const xquery = context.getQuery("No", "=", dAftCNo);
            context.RelatedData.Customers(xquery).then(function (response) {
                const dAftCNolc = dAftCNo.toLowerCase();
                const lookUpEntity = response.filter(itm => itm.no.toLowerCase() === dAftCNolc);
                if (lookUpEntity.length > 1) warn('there are more then one result-> can\'t handle', 0);
                if (lookUpEntity.length < 1) return warn('there are no such customer', 0);

                const customer = lookUpEntity[0];
                const curEntity = XPortal.Store.GetModelByName(action.model).entity;
                dispatchIfDiff(action.model, curEntity, customer, "SellToPhoneNo", "PhoneNo", true, false);
                dispatchIfDiff(action.model, curEntity, customer, "SellToContact", "Contact", true, false);
                dispatchIfDiff(action.model, curEntity, customer, "SellToEmail", "Email", true, false);
                const currval = getObjValue(customer, "currencycode");
                dispatchIfDiff(action.model, curEntity, customer, "currencycode", currval ? "currencycode" : "lcycode", true, false);

            }, function (h, e, o) { });
        },
        /* PPS03 - Get Support customer Info by No */
        async PPS03_UpdateShippingAddressDetails(context, action, next) {
            if (!context || !action || !context.RelatedData.ShipToAddress) return warn('event to [update shipping address details] has been called incorrectly!!!', 1);
            if (!context.isOneOfFields(action, "shiptocode") || !context.isForEntity("SalesOrderHeader")) return;

            const before = XPortal.Store.GetModelByName(action.model).entity;
            const dBfrCode = getObjValueLCase(before, "shiptocode");
            next(action);
            action.preventDefault = true;

            const curModel = XPortal.Store.GetModelByName(action.model);
            const dAftCode = getObjValueLCase(curModel.entity, "shiptocode");
            var setValues = (resEntity) => {
                const curEntity = XPortal.Store.GetModelByName(action.model).entity;
                dispatchIfDiff(action.model, curEntity, resEntity, "ShiptoPostCode", "PostCode");
                dispatchIfDiff(action.model, curEntity, resEntity, "ShiptoCity", "City");
                dispatchIfDiff(action.model, curEntity, resEntity, "ShipToAddress", "Address");
                dispatchIfDiff(action.model, curEntity, resEntity, "ShiptoCountryRegionCode", "CountryRegionCode");
            };

            if (dBfrCode == dAftCode) return;
            if (!dAftCode) { setValues({}); return; }
            const xquery = context.getQuery("code", "=", dAftCode);
            context.RelatedData.ShipToAddress(xquery).then(function (response) {
                const dAftCodeLC = dAftCode.toLowerCase();
                const lookUpEntity = response.filter(itm => itm.code.toLowerCase() === dAftCodeLC);
                if (lookUpEntity.length > 1) warn('there are more then one result-> can\'t handle', 0);
                if (lookUpEntity.length < 1) return warn('there are no such ship to adress', 0);
                setValues(lookUpEntity[0]);
            }, function (h, e, o) { });
        }
    };
    function setItemDescription(response, curEntity, action) {
        const itemDescription = getObjValue(response, "ItemDescription");
        const variant = getObjValue(curEntity, "variantcode");
        const description = variant.length ? (itemDescription + " - " + variant) : itemDescription;
        XPortal.Events.helpers.DispatchForOtherEntity(action.model, curEntity, [{ name: "description", value: String(description) }], true, null, true);
    };
    function updateTotalsFor(prtMName, action, response) {
        const prtMContainer = XPortal.Store.GetModelByName(prtMName);
        window.clearTimeout(prtMContainer.ttlTimeout);
        prtMContainer.ttlTimeout = window.setTimeout(function () {
            const crtModel = XPortal.Store.GetModelByName(action.model);
            const isDelete = action.type == 'DELETED_ENTITY' || action.type == 'GRID_DATALOADED';
            let grdLines = isDelete ? response.Lines || [] : crtModel.GetGridItems() || [];

            if (grdLines)
                grdLines = Array.from(
                    grdLines.reduce((map, item) => map.set(item.UniqueId, item), new Map()).values()
                );
            let tElxVat = 0;
            let tIclVat = 0;
            const tvat = [];
            grdLines.forEach(l => {
                const lev = Number(getObjValue(l, "LineAmount"));
                const liv = Number(getObjValue(l, "AmountIncludingVAT"));
                const lvp = Number(getObjValue(l, "VATPerc"));
                tElxVat = tElxVat + (isNaN(lev) || lev < 0 ? 0 : lev);
                tIclVat = tIclVat + (isNaN(liv) || liv < 0 ? 0 : liv);
                if (!isNaN(lvp) && lvp > 0)
                    if (tvat.find(x => x == lvp) == null) tvat.push(lvp);
            });
            const vat = tIclVat - tElxVat;
            updateTotalsFields(prtMName, vat, tIclVat, tElxVat);
        }, 1200);
    };

    function subscribeForAnyStoreChanges() {
        waitFor(function () {
            if (XPortal["Store"] && XPortal["Store"]["AppStore"]) {
                const store = XPortal.Store.AppStore;
                helpers.unsubscribe = helpers.unsubscribe || store.subscribe(() => {
                    var laction = store.getState().lastAction;
                    ensureReturnOrderComplexModifAction(laction);
                    ensureInvoiceTotalsCalc(laction);
                    ensureCreditMemoTotalsCalc(laction);
                    ensureOrderTotalsCalc(laction);
                });
                return true;
            } else return false;
        }, waitFor);
    };
    const lastTimeSyncComlexModif = [];
    function ensureReturnOrderComplexModifAction(action) {
        if (action && action.type == "Complex.ModifyRecord.Start") {
            const { modelName, button } = action;
            const exists = lastTimeSyncComlexModif.find(x => x.button == button && x.modelName == modelName);
            if (!exists)
                lastTimeSyncComlexModif.push({ button, modelName, lastPressedTime: moment() });
            else
                exists.lastPressedTime = moment();
        }
        if (!action || action.type != "Complex.ModifyRecord.Successful") return;
        const { modelName, options, button } = action;
        const actionModel = XPortal.Store.GetModelByName(modelName);
        const uniqueId = getObjValueLCase(actionModel.entity, "uniqueid");
        const documenttype = getObjValueLCase(actionModel.entity, "documenttype");

        const curEntityName = actionModel.model.Alias.toLowerCase();
        if (curEntityName != "salesorderheader") return;

        options.dontReloadPageInTheEnd = true;
        const ownPrevReload = function () {
            var bc = options.finalUrl;
            if (bc) return window.location.href = bc;
            window.location.reload(true);
        };
        XPortal.Store.GetRelatedData({
            url: "/umbraco/surface/PPackage/GetLastReturnOrderUrl", request: {
                uniqueId, documenttype, parentInfo: getParentInfo(modelName), entityAlias: actionModel.model.Alias.toLowerCase(), nodeId: actionModel.model.NodeId,
                akey: button.closest("li").attr("data-key"),
                data: JSON.stringify(actionModel.model.NodeId)
            }
        }).then(function (response) {
            if (!response || response.State < 0) return ownPrevReload();
            if (!response.ResultUrl) return ownPrevReload();

            const pressStage = lastTimeSyncComlexModif.find(x => x.button == button && x.modelName == modelName);

            if (documenttype && documenttype.toLowerCase() == "return order") {
                window.location.href = response.ResultUrl;
            } else {
                if (!response.LRetOrderDate) return ownPrevReload();
                else {
                    pressStage.ReturnFromLastPressActionMs = moment(response.LRetOrderDate).diff(pressStage.lastPressedTime);
                    if (pressStage.ReturnFromLastPressActionMs >= 0 || Math.abs(pressStage.ReturnFromLastPressActionMs) < 10000)
                        window.location.href = response.ResultUrl;
                    else
                        return ownPrevReload();

                    pressStage.lastPressedTime = moment();
                }
            };
        });
    };

    function ensureOrderTotalsCalc(action) {
        if (!action || action.type != "GRID_DATALOADED") return;
        const modelName = action.modelName || action.model;
        const actionModel = XPortal.Store.GetModelByName(modelName);
        const curEntityName = actionModel.model.Alias.toLowerCase();
        if (!(curEntityName == "salesorderline")) return;
        const prtMName = XPortal.Store.GetParentModelName(modelName);
        if (prtMName && prtMName.length > 0) {
            const prtModel = XPortal.Store.GetModelByName(prtMName);
            const prtModelEntity = prtModel.entity;
            if (!XPortal.Store.IsAnyFieldsEditable(prtMName, "Amount", "AmountIncludingVAT", "VATAmount")) return;
            XPortal.Store.GetRelatedData({
                url: "/umbraco/surface/PPackage/CalculateTotals", request: {
                    uniqueid: getObjValueLCase(prtModelEntity, "uniqueid"), parentInfo: getParentInfo(modelName), entityAlias: prtModel.model.Alias.toLowerCase(), nodeId: prtModel.model.NodeId,
                    data: JSON.stringify(actionModel.model.NodeId)
                }
            }).then(function (response) {
                if (!response || response.State < 0) return;
                setTotalsValues(response, prtMName, prtModelEntity);
            });
        }
    };
    function ensureCreditMemoTotalsCalc(action) {
        if (!action || action.type != "GRID_DATALOADED") return;
        const modelName = action.modelName || action.model;
        const actionModel = XPortal.Store.GetModelByName(modelName);
        const curEntityName = actionModel.model.Alias.toLowerCase();
        if (!(curEntityName == "salescreditmemoline")) return;
        const prtMName = XPortal.Store.GetParentModelName(modelName);
        if (prtMName && prtMName.length > 0) {
            const prtModel = XPortal.Store.GetModelByName(prtMName);
            const prtModelEntity = prtModel.entity;
            if (!XPortal.Store.IsAnyFieldsEditable(prtMName, "Amount", "AmountIncludingVAT", "VATAmount")) return;
            XPortal.Store.GetRelatedData({
                url: "/umbraco/surface/PPackage/CalculateTotals", request: {
                    uniqueid: getObjValueLCase(prtModelEntity, "uniqueid"), parentInfo: getParentInfo(modelName), entityAlias: prtModel.model.Alias.toLowerCase(), nodeId: prtModel.model.NodeId,
                    data: JSON.stringify(actionModel.model.NodeId)
                }
            }).then(function (response) {
                if (!response || response.State < 0) return;
                setTotalsValues(response, prtMName, prtModelEntity);
            });
        }
    };
    function ensureInvoiceTotalsCalc(action) {
        if (!action || action.type != "GRID_DATALOADED") return;
        const modelName = action.modelName || action.model;
        const actionModel = XPortal.Store.GetModelByName(modelName);
        const curEntityName = actionModel.model.Alias.toLowerCase();
        if (!(curEntityName == "salesinvoiceline")) return;
        const prtMName = XPortal.Store.GetParentModelName(modelName);
        if (prtMName && prtMName.length > 0) {
            const prtModel = XPortal.Store.GetModelByName(prtMName);
            const prtModelEntity = prtModel.entity;
            if (!XPortal.Store.IsAnyFieldsEditable(prtMName, "Amount", "AmountIncludingVAT", "VATAmount")) return;
            XPortal.Store.GetRelatedData({
                url: "/umbraco/surface/PPackage/CalculateTotals", request: {
                    uniqueid: getObjValueLCase(prtModelEntity, "uniqueid"), parentInfo: getParentInfo(modelName), entityAlias: prtModel.model.Alias.toLowerCase(), nodeId: prtModel.model.NodeId,
                    data: JSON.stringify(actionModel.model.NodeId)
                }
            }).then(function (response) {
                if (!response || response.State < 0) return;
                setTotalsValues(response, prtMName, prtModelEntity);
            });
        }
    };
    function setTotalsValues(response, prtMName, prtModelEntity) {
        if (getObjValue(response, "AmountExclVAT"))
            dispatchIfDiff(prtMName, prtModelEntity, response, "Amount", "AmountExclVAT");
        if (getObjValue(response, "AmountInclVAT"))
            dispatchIfDiff(prtMName, prtModelEntity, response, "AmountIncludingVAT", "AmountInclVAT");
        if (getObjValue(response, "VAT"))
            dispatchIfDiff(prtMName, prtModelEntity, response, "VATAmount", "VAT");
    };

    function dispatchIfDiff(modelName, curData, srcData, cFname, sFname, omitAutoSave = false, updateGrid = true) {
        var cval = getObjValue(curData, cFname);
        var sval = getObjValue(srcData, sFname);
        if (cval != sval) {
            XPortal.Store.DispatchByName(modelName, cFname, sval, omitAutoSave, updateGrid);
        }
    };
    function getSimpleProperties(obj) {
        if (!obj) return obj;
        const r = {};
        for (var i in obj) {
            const v = obj[i];
            if (i == i.toLowerCase() && typeof (v) != "function" && i[0] != "_" && i.indexOf("field") == -1 && i.indexOf("defaults") == -1) {
                r[i] = obj[i];
            }
        }
        if (obj.Fields && obj.Fields.length) {
            r.Fields = [];
            obj.Fields.forEach(x => {
                r.Fields.push({ Name: x.Name, Type: x.Type, Data: x.StringValue });
            });
        }
        return r;
    };
    function getParentInfo(modelName) {
        const pmodelName = XPortal.Store.GetParentModelName(modelName);
        const pmodel = pmodelName ? XPortal.Store.GetModelByName(pmodelName) : null;
        if (!pmodel) return null;
        const parentUid = (XPortal.Template.GetObjPropValueByName(pmodel.entity || {}, "uniqueid") || "");
        if (!parentUid || !pmodel.model) return null;
        return pmodel.model.NodeId + "#|#" + parentUid;
    };
    function getObjValue(o, prname, dval) {
        const r = XPortal.Template.GetObjPropValueByName(o, prname);
        if (dval && !r) return dval;
        return r;
    };
    function getObjValueLCase(o, prname) {
        const v = XPortal.Template.GetObjPropValueByName(o, prname);
        return tLowerCase(v);
    };
    function tLowerCase(o, dv) {
        const so = o ? String(o).toLowerCase() : (dv || "").toLowerCase();
        return so;
    };
    function warn(msg, iscritical, ...args) {
        if (!console) return;
        const stack = [];// (new Error().stack || "").split("\n").slice(1).filter((x) => x.indexOf("portal.store.js") == -1 && x.indexOf("Object.event") == -1 && x.indexOf("Object.EnsureMid") == -1 && x.indexOf("warn (http") == -1);
        if (iscritical > 0) return console.error(msg, [...args, ...stack]);
        if (iscritical == 0) return console.warn(msg, [...args, ...stack]);
        return console.log(msg, [...args, ...stack]);
    };
    function updateTotalsFields(prtMName, vat, tIclVat, tElxVat) {
        XPortal.Store.DispatchByName(prtMName, "vat", String(vat), false);
        XPortal.Store.DispatchByName(prtMName, "AmountIncludingVAT", String(tIclVat), false);
        XPortal.Store.DispatchByName(prtMName, "Amount", String(tElxVat), false);
    };

    //register events in repository
    function waitFor(onAction, onFalse) { if (!onAction()) { setTimeout(function () { onFalse(onAction, onFalse); }, 100); } };
    waitFor(function () {
        if (XPortal["Events"] && XPortal["Events"]["helpers"]) {
            for (var i in helpers) XPortal.Events.helpers[i] = helpers[i];
            subscribeForAnyStoreChanges();
            return true;
        } else return false;
    }, waitFor);
    //end of registration
    return helpers;
})();

